import * as React from 'react';
import { compose, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import classNames from 'classnames';
import { transition } from '@topconagriculture/theme';
const styles = (theme) => createStyles({
    drillDownButton: {
        cursor: 'pointer',
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        width: 100,
        height: '100%',
        zIndex: 101,
        right: 0,
        top: 0,
        background: 'linear-gradient(to right, rgba(201, 201, 201, 0.9), rgba(153, 153, 153, 0.9))',
        transform: 'translateX(100px)',
    },
    drillDownButtonHover: {
        transition: transition(),
        transform: 'translateX(0)',
    },
    drillDownButtonOnSelectedItem: {
        background: 'linear-gradient(to right, rgba(79, 160, 0, 0.85), rgba(38, 98, 1, 0.85))',
        color: theme.color.font.light,
    },
    drillDownLabel: {
        fontSize: theme.font.size.small,
        marginLeft: 10,
        width: 60,
        textTransform: 'uppercase',
        lineHeight: '1.5em',
    },
    drillDownIcon: {
        fontSize: 20,
        marginTop: 2,
    },
});
const DrillDownButton = (props) => {
    const { classes, hoveredItemId, listItemId, listItemIsSelected, onDrillDownClick, testId = 'DrillDownButton', label, } = props;
    const drillDownButtonClasses = classNames({
        [classes.drillDownButton]: true,
        [classes.drillDownButtonHover]: listItemIsSelected || hoveredItemId === listItemId,
        [classes.drillDownButtonOnSelectedItem]: listItemIsSelected,
    });
    return (React.createElement("div", { "data-testid": testId, className: drillDownButtonClasses, onClick: onDrillDownClick },
        React.createElement("span", { className: classes.drillDownLabel }, label),
        React.createElement("span", { className: classNames(classes.drillDownIcon, `icon-go-to`) })));
};
const ComposedDrillDownButton = compose(pure, withStyles(styles, { withTheme: true }))(DrillDownButton);
ComposedDrillDownButton.displayName = 'DrillDownButton';
export default ComposedDrillDownButton;
//# sourceMappingURL=DrillDownButton.js.map